var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10 10-4.478 10-10S15.522 0 10 0zm3.728 14.143c-.907.835-2.143 1.326-3.619 1.326A5.465 5.465 0 014.643 10a5.47 5.47 0 015.466-5.471c1.474 0 2.71.542 3.659 1.424L12.2 7.523c-.567-.543-1.288-.818-2.09-.818-1.424 0-2.629.962-3.06 2.255-.109.328-.172.678-.172 1.04s.063.712.172 1.04c.431 1.293 1.636 2.255 3.058 2.255.737 0 1.362-.195 1.85-.523.581-.388.965-.966 1.092-1.652H10.11V9.005h5.15c.065.36.098.733.098 1.119 0 1.667-.596 3.067-1.63 4.02z",
    fill: "#fff"
  })));
}

export default SvgGoogle;